import { Sun, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-primary text-primary-foreground py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="bg-gradient-energy p-2 rounded-lg">
                <Sun className="h-6 w-6 text-primary-foreground" />
              </div>
              <h3 className="text-2xl font-bold">PASAT COMPANY</h3>
            </div>
            <p className="text-primary-foreground/80 leading-relaxed">
              Leading the solar revolution with premium installations, exceptional service, and sustainable energy solutions for homes and businesses.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3 text-primary-foreground/80">
              <li>
                <button 
                  onClick={() => scrollToSection('solar-panels')}
                  className="hover:text-primary-foreground transition-colors"
                >
                  Residential Solar
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('solar-panels')}
                  className="hover:text-primary-foreground transition-colors"
                >
                  Commercial Solar
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('solar-panels')}
                  className="hover:text-primary-foreground transition-colors"
                >
                  Industrial Solar
                </button>
              </li>
              <li>
                <button className="hover:text-primary-foreground transition-colors">
                  Maintenance & Monitoring
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Company</h4>
            <ul className="space-y-3 text-primary-foreground/80">
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="hover:text-primary-foreground transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('partners')}
                  className="hover:text-primary-foreground transition-colors"
                >
                  Partners
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('reviews')}
                  className="hover:text-primary-foreground transition-colors"
                >
                  Customer Reviews
                </button>
              </li>
              <li>
                <button className="hover:text-primary-foreground transition-colors">
                  Careers
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact</h4>
            <div className="space-y-3 text-primary-foreground/80">
              <p>(555) 123-SOLAR</p>
              <p>info@pasatcompany.com</p>
              <p>123 Solar Street<br />Energy City, EC 12345</p>
            </div>
            <div className="flex space-x-4 mt-6">
              <button className="hover:text-solar-yellow transition-colors">
                <Facebook className="h-5 w-5" />
              </button>
              <button className="hover:text-solar-yellow transition-colors">
                <Twitter className="h-5 w-5" />
              </button>
              <button className="hover:text-solar-yellow transition-colors">
                <Instagram className="h-5 w-5" />
              </button>
              <button className="hover:text-solar-yellow transition-colors">
                <Linkedin className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-primary-foreground/60 text-sm mb-4 md:mb-0">
              © 2024 PASAT COMPANY. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-primary-foreground/60">
              <button className="hover:text-primary-foreground transition-colors">Privacy Policy</button>
              <button className="hover:text-primary-foreground transition-colors">Terms of Service</button>
              <button className="hover:text-primary-foreground transition-colors">Cookie Policy</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;